export const CONFIGURABLE_MATERIAL_SYMBOL_NAMES = [
    'arrow_upward_alt',
    'attach_file',
    'autorenew',
    'close',
    'edit_square',
    'mic',
    'north',
    'refresh',
    'restart_alt',
    'search',
    'send',
];
const WIDGET_MATERIAL_SYMBOL_NAMES = [
    'arrow_back',
    'arrow_forward',
    'arrow_upward',
    'auto_awesome',
    'check',
    'chevron_left',
    'chevron_right',
    'content_copy',
    'favorite',
    'pending',
    'photo_camera',
    'star_half',
    'star_rate',
    'stop_circle',
    'thumb_down',
    'thumb_up',
];
export const MATERIAL_SYMBOL_NAMES = Array.from(new Set([
    ...CONFIGURABLE_MATERIAL_SYMBOL_NAMES,
    ...WIDGET_MATERIAL_SYMBOL_NAMES,
])).sort();
export const MATERIAL_SYMBOLS_HREF = `https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:FILL@0..1` +
    `&icon_names=${MATERIAL_SYMBOL_NAMES.join(',')}&display=block`;
export function ensureMaterialSymbols() {
    try {
        const href = MATERIAL_SYMBOLS_HREF;
        const existingLink = document.querySelector(`link[href*='fonts.googleapis.com/css2?family=Material+Symbols+Outlined']`);
        if (existingLink)
            return;
        const ensureHint = (rel, url, crossOrigin = false) => {
            if (document.querySelector(`link[rel="${rel}"][href="${url}"]`))
                return;
            const l = document.createElement('link');
            l.rel = rel;
            l.href = url;
            if (crossOrigin)
                l.crossOrigin = 'anonymous';
            document.head.appendChild(l);
        };
        // Prewarm DNS and connections
        ensureHint('dns-prefetch', 'https://fonts.googleapis.com');
        ensureHint('dns-prefetch', 'https://fonts.gstatic.com');
        ensureHint('preconnect', 'https://fonts.googleapis.com');
        ensureHint('preconnect', 'https://fonts.gstatic.com', true);
        // Try preload-as-style, then swap to stylesheet onload
        if (!document.querySelector(`link[rel="preload"][as="style"][href="${href}"]`)) {
            const preload = document.createElement('link');
            preload.rel = 'preload';
            preload.setAttribute('as', 'style');
            preload.href = href;
            preload.onload = () => {
                try {
                    preload.rel = 'stylesheet';
                }
                catch {
                    /* ignore swap failure; stylesheet will load separately */
                }
            };
            document.head.appendChild(preload);
        }
        // Also ensure a regular stylesheet (covers browsers ignoring preload swap)
        let sheet = document.querySelector(`link[rel="stylesheet"][href="${href}"]`);
        if (!sheet) {
            sheet = document.createElement('link');
            sheet.rel = 'stylesheet';
            sheet.href = href;
            document.head.appendChild(sheet);
        }
        const warm = () => {
            try {
                // Hint the font subsystem to load the face now
                const fontsApi = document.fonts;
                fontsApi?.load?.("24px 'Material Symbols Outlined'");
                fontsApi?.load?.("1em 'Material Symbols Outlined'");
            }
            catch {
                /* fonts API not available; rely on stylesheet load */
            }
            // Additionally, create a hidden icon element to force glyph usage
            const warmId = 'shine-icons-warmup';
            if (!document.getElementById(warmId)) {
                const span = document.createElement('span');
                span.id = warmId;
                span.className = 'material-symbols-outlined';
                span.textContent = 'close';
                span.setAttribute('aria-hidden', 'true');
                span.style.cssText = 'position:absolute;left:-9999px;top:-9999px;width:0;height:0;overflow:hidden;opacity:0;pointer-events:none;';
                (document.body || document.documentElement).appendChild(span);
                // Remove after a short delay
                setTimeout(() => {
                    try {
                        span.remove();
                    }
                    catch {
                        /* element already removed */
                    }
                }, 2000);
            }
        };
        if (sheet.sheet) {
            // Already loaded/parsed; warm now
            warm();
        }
        else {
            const onceOptions = { once: true };
            sheet.addEventListener('load', warm, onceOptions);
            // Fallback: warm after a short delay even if onload doesn't fire
            setTimeout(warm, 1000);
        }
    }
    catch {
        /* icon preload best-effort; ignore failures */
    }
}
